export const ErrorConstants = {
    DEFAULT_ERROR_MESSAGE: "Something went wrong! Please contact our support team.",
    COULD_NOT_RETRIEVE_THE_DOCUMENTS: "We could not retrieve the documents. Please try again.",
    COULD_NOT_RETRIEVE_AN_ANSWER: "We could not retrieve an answer. Please try again.",
    PLEASE_ENTER_A_SEARCH_TERM: "Please enter a search term.",
} as const;
